import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useRoutesHook from 'routes/routes';

function App() {
  const routes = useRoutesHook();
  const location = useLocation();
  const { pathname } = location;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return <div className='landingPage DBlock'>{routes}</div>;
}

export default App;
